import { render, staticRenderFns } from "./MarketPriceConfig.vue?vue&type=template&id=7b6fc7cc&scoped=true&"
import script from "./MarketPriceConfig.vue?vue&type=script&lang=js&"
export * from "./MarketPriceConfig.vue?vue&type=script&lang=js&"
import style0 from "./MarketPriceConfig.vue?vue&type=style&index=0&id=7b6fc7cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6fc7cc",
  null
  
)

export default component.exports